module.exports = __webpack_public_path__ + "static/img/senceIcon2.2cbff34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senceIcon2.png
// module id = z1jA
// module chunks = 1